module.exports = __webpack_public_path__ + "static/img/video.8d485401.svg";